module.exports = __webpack_public_path__ + "img/1-22.06c5e8e5.jpg";